// SL limitations
export const MAX_ROW_NUMBER = 1000000;
export const CONTROL_PARSE_VALUE = 20;
export const COLUMNS_THRESHOLD = 0.4;
export const CONTACTS_CONTROL_PARSE_VALUE = 20;
export const MAX_CONTACTS_ROW_NUMBER = 5000;

// SL Parsing regular expressions
export const INVALID_DOMAIN_REG_EX = /[!@#$%¬£^&±~*()_+\=\[\]{};':"\\,<>\/?\s]/g;
export const TRIM_QUOTES_REG_EX = /"/g;
export const TRIM_WWW_REG_EX = /^www./;
export const TRIM_SUB_SITE_REG_EX = /\/.*/;
export const TRIM_PREFIXES_REG_EX = /.*:\/\//;
export const WITH_DOT_AND_NOT_A_NUM_REG_EX = /[.]\D/g;

export const MAX_NAME_WIDTH = 256;
